const Account = () => import(/* webpackChunkName: "group-account" */ '@/components/account/account')
const AccountHome = () => import(/* webpackChunkName: "group-account" */ '@/components/account/account-home')
const AccountHomeDefault = () => import(/* webpackChunkName: "group-account" */ '@/components/account/account-home-default')

const Login = () => import(/* webpackChunkName: "group-auth" */ '@/components/account/login')
const ResetPassword = () => import(/* webpackChunkName: "group-auth" */ '@/components/account/reset-password')
const Register = () => import(/* webpackChunkName: "group-auth" */ '@/components/account/register')
const CommunityAuth = () => import(/* webpackChunkName: "group-auth" */ '@/components/account/community-auth')
const FreePass = () => import(/* webpackChunkName: "group-auth" */ '@/components/account/redeem-free-pass')

export default {
  path: '/account',
  component: Account,

  children: [{
    path: '/login',
    component: Login,
    meta: {
      noAuthentication: true
    }
  },
  {
    path: '/register',
    component: Register,
    meta: {
      noAuthentication: true
    }
  },
  {
    path: '/reset-password',
    component: ResetPassword,
    meta: {
      noAuthentication: true
    }
  },
  {
    path: '/redeem-pass',
    component: FreePass,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '',
    component: AccountHome,
    meta: {
      requiresAuth: true
    },
    children: [{
      path: '',
      component: AccountHomeDefault,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'community-auth',
      component: CommunityAuth,
      meta: {
        requiresAuth: true
      }
    }]
  },
  {
    name: 'account-pay', path: 'pay', redirect: '/account'
  }
  ]
}
